<template>
  <aside class="jd-sidebar">
    <div class="jd-sidebar__card">
      <JobDetailApply
        :job="job"
        :applied="applied"
        :expired="expired"
        :q-result="qResult"
        :has-questionnaire="hasQuestionnaire"
        :error="error"
        :err-msg="errMsg"
        compact
        @apply="$emit('apply')"
      />
      <button type="button" class="hp-btn hp-btn--outline jd-sidebar__share" @click="$emit('share')">
        <v-icon size="16">{{ $icons.link }}</v-icon>
        Copy link
      </button>
    </div>

    <div class="jd-sidebar__card jd-sidebar__facts" v-if="facts.length">
      <h3 class="jd-sidebar__title">Job snapshot</h3>
      <dl class="jd-facts">
        <div v-for="fact in facts" :key="fact.label" class="jd-facts__row">
          <dt>{{ fact.label }}</dt>
          <dd>{{ fact.value }}</dd>
        </div>
      </dl>
    </div>

    <div class="jd-sidebar__visume">
      <p class="jd-sidebar__visume-title">Stand out with <span>#visume</span></p>
      <p class="jd-sidebar__visume-text">Candidates with a video profile see up to 40% higher shortlist rates.</p>
      <a href="/jobseeker/register" class="hp-btn hp-btn--outline jd-sidebar__visume-btn">Create video profile</a>
    </div>
  </aside>
</template>

<script>
import JobDetailApply from '@/components/job/JobDetailApply.vue';

export default {
  name: 'JobDetailSidebar',
  components: { JobDetailApply },
  props: {
    job: { type: Object, default: null },
    jobType: { type: String, default: '' },
    experience: { type: String, default: '' },
    courses: { type: Array, default: () => [] },
    branches: { type: Array, default: () => [] },
    postedDate: { type: String, default: '' },
    applied: { type: Boolean, default: false },
    expired: { type: Boolean, default: false },
    qResult: { type: Number, default: 0 },
    hasQuestionnaire: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    errMsg: { type: String, default: null },
    getGender: { type: Function, required: true },
  },
  computed: {
    facts() {
      if (!this.job) return [];
      const items = [];
      if (this.jobType) items.push({ label: 'Job type', value: this.jobType });
      if (this.experience) items.push({ label: 'Experience', value: this.experience });
      if (this.job.last_date) items.push({ label: 'Last date', value: this.job.last_date });
      if (this.postedDate) items.push({ label: 'Posted on', value: this.postedDate });
      if (!this.job.salary_flag && (this.job.salary_range_from || this.job.salary_range_to)) {
        let sal = '₹' + this.job.salary_range_from;
        if (this.job.salary_range_to) sal += ' – ₹' + this.job.salary_range_to;
        items.push({ label: 'Salary', value: sal + '/month' });
      }
      if (this.job.number_of_vacancy) items.push({ label: 'Vacancies', value: String(this.job.number_of_vacancy) });
      if (this.courses.length) items.push({ label: 'Education', value: this.courses.join(', ') });
      if (this.branches.length) items.push({ label: 'Branch', value: this.branches.join(', ') });
      if (this.job.gender) items.push({ label: 'Gender', value: this.getGender(this.job.gender) });
      if (this.job.hiring_process) items.push({ label: 'Hiring', value: this.job.hiring_process });
      return items;
    },
  },
};
</script>
